(function () {
  function getCards(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.fclo-ctl__card'));
  }

  function getStep(track) {
    var cards = getCards(track);
    if (!cards.length) return track.clientWidth * 0.8;

    var first = cards[0];
    var second = cards[1];
    if (second) {
      return Math.max(1, second.offsetLeft - first.offsetLeft);
    }

    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return first.offsetWidth + gap;
  }

  function syncNav(root) {
    var track = root.querySelector('[data-fclo-ctl-track]');
    var nav = root.querySelector('[data-fclo-ctl-nav]');
    var prev = root.querySelector('[data-fclo-ctl-prev]');
    var next = root.querySelector('[data-fclo-ctl-next]');
    if (!track || !nav || !prev || !next) return;

    var cards = getCards(track);
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 1);
    var canScroll = cards.length > 0 && maxScroll > 0;

    nav.hidden = !canScroll;
    if (!canScroll) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    var left = track.scrollLeft;
    prev.disabled = left <= 1;
    next.disabled = left >= maxScroll;
  }

  function scrollByStep(root, direction) {
    var track = root.querySelector('[data-fclo-ctl-track]');
    if (!track) return;

    var step = getStep(track);
    track.scrollBy({
      left: direction * step,
      behavior: 'smooth'
    });
  }

  function bind(root) {
    if (!root || root.dataset.fcloCtlBound === 'true') return;
    root.dataset.fcloCtlBound = 'true';

    var track = root.querySelector('[data-fclo-ctl-track]');
    var prev = root.querySelector('[data-fclo-ctl-prev]');
    var next = root.querySelector('[data-fclo-ctl-next]');
    if (!track || !prev || !next) return;

    prev.addEventListener('click', function () {
      scrollByStep(root, -1);
    });

    next.addEventListener('click', function () {
      scrollByStep(root, 1);
    });

    track.addEventListener('scroll', function () {
      syncNav(root);
    }, { passive: true });

    window.addEventListener('resize', function () {
      syncNav(root);
    });

    var complimentary = root.querySelector('product-complimentary');
    if (complimentary && window.MutationObserver) {
      new MutationObserver(function () {
        window.requestAnimationFrame(function () {
          syncNav(root);
        });
      }).observe(complimentary, { childList: true, subtree: true });
    }

    var tries = 0;
    var retry = window.setInterval(function () {
      syncNav(root);
      tries += 1;
      if (tries > 30 || !root.classList.contains('js-unloaded')) {
        syncNav(root);
        if (tries > 30) window.clearInterval(retry);
      }
      if (!root.classList.contains('js-unloaded') && tries > 5) {
        window.clearInterval(retry);
      }
    }, 200);

    syncNav(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fclo-ctl]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
